// extracted by mini-css-extract-plugin
module.exports = {"details":"_21a3b4d","detailsExpanded":"_9586288","detailsItemHeading":"_e20dffe"};